<div class="container margin-nav mat-elevation-z8">
  <app-titulo [(titulo)]="titulo"></app-titulo>
  <br />
  <div class="rowWrap center">
    <form class="formContainer" [formGroup]="formulario" (ngSubmit)="onSubmit()">
      <div class="row">
        <mat-form-field appearance="outline" class="w50">
          <mat-label>Identificação do cliente sem registro</mat-label>
          <div class="busca">
            <input hidden formControlName="idClienteSemRegistro" />
            <input matInput id="inputCooperado" type="text" readonly />
            <mat-icon (click)="pesquisaCooperado()">search</mat-icon>
          </div>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w30">
          <mat-label>Status</mat-label>
          <mat-select #idStatusNovaCotacao formControlName="idStatusNovaCotacao">
            <mat-select-filter *ngIf="idStatusNovaCotacao.focused" [displayMember]="'descricao'"
              [placeholder]="'Procurando..'" [array]="status" (filteredReturn)="statusFiltrados = $event">
            </mat-select-filter>
            <mat-option *ngFor="let status of statusFiltrados" [value]="status.id">{{ status.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="w20" appearance="outline">
          <mat-label>Qtde Chamados abertos por Assessor</mat-label>
          <input matInput #qtdeChamadosAbertosPorAssessor type="number"
            formControlName="qtdeChamadosAbertosPorAssessor" />
        </mat-form-field>
        <mat-form-field class="w20" appearance="outline">
          <mat-label>Qtde Clientes gera visita (padrão)</mat-label>
          <input matInput #qtdeClientesGeraVisita type="number" formControlName="qtdeClientesGeraVisita" />
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field class="w20" appearance="outline">
          <mat-label>Abrir Cotação Futura (dias)</mat-label>
          <input matInput #QtdeDiasAbrirCotacaoFutura type="number" formControlName="qtdeDiasAbrirCotacaoFutura" />
        </mat-form-field>
        <mat-form-field class="w20" appearance="outline">
          <mat-label>Avisar parcelas (dias)</mat-label>
          <input matInput #DiasLembreteParcelas type="number" formControlName="diasLembreteParcelas" />
        </mat-form-field>
        <mat-checkbox formControlName="pesquisaClienteAgendaPorCarteira">Pesquisa de Clientes na Agenda conforme
          Carteira</mat-checkbox>
        <mat-checkbox formControlName="habilitarComissionadoNaCotacao">Habilita a inclusão de Comissionados nas
          Cotações</mat-checkbox>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="w30">
          <mat-label>Status para finalizar Chamado no MCI</mat-label>
          <mat-select #statusIdFinalizaChamado formControlName="statusIdFinalizaChamado">
            <mat-select-filter *ngIf="statusIdFinalizaChamado.focused" [displayMember]="'descricao'"
              [placeholder]="'Procurando..'" [array]="statusFinaliza"
              (filteredReturn)="statusFinalizaFiltrados = $event">
            </mat-select-filter>
            <mat-option *ngFor="let status of statusFinalizaFiltrados" [value]="status.id">{{ status.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-checkbox formControlName="pesquisaClienteAgendaPorCarteira">Pesquisa de Clientes na Agenda conforme
          Carteira</mat-checkbox>
        <mat-checkbox formControlName="exibirCuponsPorAgrupamento">Exibe os cupons Agrupados por Termo de
          Adesão</mat-checkbox>
      </div>
      <br />
      <div class="row">
        <mat-form-field appearance="outline" class="w30">
          <mat-label>Status para Cotando no PA</mat-label>
          <mat-select #statusIdCotandoNoPA formControlName="idStatusCotarNoPA">
            <mat-select-filter *ngIf="statusIdCotandoNoPA.focused" [displayMember]="'descricao'"
              [placeholder]="'Procurando..'" [array]="statusFinaliza"
              (filteredReturn)="statusFinalizaFiltrados = $event">
            </mat-select-filter>
            <mat-option *ngFor="let status of statusFinalizaFiltrados" [value]="status.id">{{ status.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w30">
          <mat-label>Status para Conferir no PA</mat-label>
          <mat-select #statusIdConferirNoPA formControlName="idStatusConferirNoPA">
            <mat-select-filter *ngIf="statusIdConferirNoPA.focused" [displayMember]="'descricao'"
              [placeholder]="'Procurando..'" [array]="statusFinaliza"
              (filteredReturn)="statusFinalizaFiltrados = $event">
            </mat-select-filter>
            <mat-option *ngFor="let status of statusFinalizaFiltrados" [value]="status.id">{{ status.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w30">
          <mat-label>Status para Pendência no PA</mat-label>
          <mat-select #statusIdPendenciaNoPA formControlName="idStatusPendenciaDoPA">
            <mat-select-filter *ngIf="statusIdPendenciaNoPA.focused" [displayMember]="'descricao'"
              [placeholder]="'Procurando..'" [array]="statusFinaliza"
              (filteredReturn)="statusFinalizaFiltrados = $event">
            </mat-select-filter>
            <mat-option *ngFor="let status of statusFinalizaFiltrados" [value]="status.id">{{ status.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="w30">
          <mat-label>Status para Aguardando Retorno do PA</mat-label>
          <mat-select #statusIdAguardandoRetornoPA formControlName="idStatusAguardandoRetornoPA">
            <mat-select-filter *ngIf="statusIdAguardandoRetornoPA.focused" [displayMember]="'descricao'"
              [placeholder]="'Procurando..'" [array]="statusFinaliza"
              (filteredReturn)="statusFinalizaFiltrados = $event">
            </mat-select-filter>
            <mat-option *ngFor="let status of statusFinalizaFiltrados" [value]="status.id">{{ status.descricao }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row">
        <button mat-button class="btn-fit-blue" (click)="addPermissao()" type="button"><mat-icon>add</mat-icon> Adicionar Permissão para Cotar no PA</button>
      </div>
      <div class="table-responsive">
        <div class="titulo-tabela">
          PA´s com  permissão para Cotar
        </div>
        <table mat-table [dataSource]="dataSource">
          <!-- Coluna codPA -->
          <ng-container matColumnDef="codPA">
            <th class="left" mat-header-cell *matHeaderCellDef mat-sort-header>PA </th>
            <td mat-cell *matCellDef="let row">{{ row.codPA }} -  {{ row.agencia.cidade }}
          </ng-container>

          <!-- Coluna DataPermissao -->
          <ng-container matColumnDef="dataPermissao">
            <th class="left" mat-header-cell *matHeaderCellDef mat-sort-header>Data da Permissao</th>
            <td mat-cell *matCellDef="let row">
              {{ row.dataPermissao | date : "dd/MM/yyyy HH:mm" }}
            </td>
          </ng-container>

           <!-- Coluna Acoes -->
          <ng-container matColumnDef="acoes">
            <th class="left" mat-header-cell *matHeaderCellDef mat-sort-header>Ações</th>
            <td mat-cell *matCellDef="let row">
              <a mat-button matTooltip="{{ 'Insere uma nova permissão' }}" matTooltipClass="tooltip-green" (click)="addPermissao()"><mat-icon class="green">add</mat-icon></a>
              <a matTooltip="{{ 'Remove a permissão do PA selecionado' }}" matTooltipClass="tooltip-red" mat-button (click)="removerPermissao(row)"><mat-icon class="red">delete</mat-icon></a>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ selectedRow: row?.codPA === paSelecionado }"
            (click)="rowClick(row)">
          </tr>
        </table>
      </div>
      <app-paginator [(length)]="qtdeRegistros" [pageSize]="paginator.pageSize"
        [pageIndex]="paginator.pageIndex"  *ngIf="dataSource.filteredData.length > 0"></app-paginator>
      <div class="item-right">
        <button mat-button class="btnOK mat-elevation-z8" type="submit">
          Salvar
        </button>
        <button mat-button class="btnCancel mat-elevation-z8" type="button" (click)="cancelar()">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</div>